module.exports = require("websocket-as-promised");